module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt_BR":{"nav":{"reports":"Relatórios","plan":"Pacotes","logout":"Sair","open":"Menu","close":"Fechar","campaign_create":"Criar mensagem","campaign_show":"Detalhes","invoice":"Faturas","invoice_paypal":"Paypal","admin":"Administração","overview":"Visão Geral"},"message":"Criar Mensagem","balance":{"text":"Saldo:","without":"Sem saldo | Comprar"}}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Main.vue
// module id = 96
// module chunks = 0